import React,{useState,useEffect} from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import ProcessInformation from '../../ProcessInformation/pages/ProcessInformation';
import ComplainHandling from '../../ComplainHandling/pages/ComplainHandling';
import SocialMedia from '../../SocialMedia/pages/SocialMedia';
import ManageFaq from '../../ManageFaq/pages/ManageFaq';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AgainstProductFaq from '../../AgainstProductFaq/pages/AgainstProductFaq';
import AgainstProductComplaint from '../../AgainstProductComplaint/pages/AgainstProductComplaint';
import AgainstProductSocialMedia from '../../AgainstProductSocialMedia/pages/AgainstProductSocialMedia';
import AgainstProductProcessView from './AgainstProductProcessView';

import appUrl from '../../../../constants/appUrl';

const AgainstProductProcess = () => {
   const [productList, setProductList] = useState([]);
   const [selectedProductId, setSelectedProductId] = useState(null);

   const GetProductName = async () => {
      try {
         const response = await fetch(`${appUrl.baseUrl}api/Product/GetAllProducts`);
         const data = await response.json();
         setProductList(data);

      } catch (error) {
         console.error('Error fetching products:', error);
      }
   };

   useEffect(() => {
      GetProductName();
   }, []);
   const handleGetId = (productId) => {
      setSelectedProductId(productId);
   }
   const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true, 
   };


   return (
      <>
         <div className="card">
         <Slider {...settings}>
               {productList.map((product) => (
                  <div key={product.id} className='card p-3 blue text-center' onClick={() => handleGetId(product)}>
                     <h4>{product.productName}</h4>
                  </div>
               ))}
            </Slider>
            <div className=''>
            <TabView>
               <TabPanel header="Process Information">
                  <AgainstProductProcessView product={selectedProductId}/>
               </TabPanel>
               <TabPanel header="Complaint Handling">
                  <AgainstProductComplaint product={selectedProductId}/>
               </TabPanel>
               <TabPanel header="Social Media">
                  <AgainstProductSocialMedia product={selectedProductId} />
               </TabPanel>
               <TabPanel header="FAQs">
                  <AgainstProductFaq product={selectedProductId}/>
               </TabPanel>
            </TabView>
            </div>
         </div>
      </>
   );
};

export default AgainstProductProcess;
